import { mix, observable } from "@chorda/core";
import { Image } from "chorda-bulma";
import { Custom } from "../../utils";
import './ListBox.scss';
export const ListBox = (props) => {
    return mix({
        css: 'list-box'
    }, props === null || props === void 0 ? void 0 : props.as, props && {
        defaultItem: props.defaultItem,
        items: props.items,
    });
};
export const ListBoxItem = (props) => {
    return mix({
        css: 'list-box-item',
        templates: {
            content: {
                css: 'list-box-item__content',
                components: {
                    subtitle: false
                },
                templates: {
                    subtitle: {
                        css: 'list-box-item__subtitle',
                        weight: 10,
                        reactions: {
                            subtitle: (v) => ({ text: v })
                        }
                    }
                },
                reactions: {
                    text: (v) => ({ text: v }),
                    subtitle: (v) => ({ components: { subtitle: !!v } })
                }
            },
            image: Custom({
                css: 'list-box-item__image',
                classes: {
                    'is-after': true
                },
                weight: 10,
                as: Image({
                    rounded: true,
                    url$: (scope) => scope.image
                })
            })
        }
    }, props === null || props === void 0 ? void 0 : props.as, props && {
        templates: {
            image: props.image,
            content: {
                text: props.text,
                templates: {
                    subtitle: {
                        text: props.subtitle
                    }
                },
                components: {
                    subtitle: !!props.subtitle
                },
            }
        },
        injections: {
            text: props.text$,
            subtitle: props.subtitle$ || (() => observable(props.subtitle)),
            image: props.image$
        }
    });
};
